import builder from '../builder';
import Close from '../../streamline-icons/bold/close.svg';

export default builder('IconCloseBold', Close);
